const t = (o) => ({
  wrapper: {
    backgroundColor: o.palette.common.green20
  },
  heading: {
    color: o.palette.common.blue400,
    "@media(max-width: 600px)": {
      fontSize: o.typography.fontSize22
    }
  },
  subHeading: {
    color: o.palette.common.grey300,
    "@media(max-width: 600px)": {
      fontSize: o.typography.fontSize14
    }
  },
  card: {
    maxWidth: 660,
    margin: "0 auto"
  },
  cardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  title: {
    color: o.palette.common.blue400,
    "@media(max-width: 600px)": {
      fontSize: o.typography.fontSize18
    }
  },
  description: {
    color: o.palette.common.blue400,
    "@media(max-width: 600px)": {
      fontSize: o.typography.fontSize14
    }
  },
  customerImg: {
    maxWidth: 64,
    maxHeight: 64,
    borderRadius: "100%",
    overflow: "hidden",
    "& > img": {
      maxWidth: 64,
      maxHeight: 64
    }
  },
  cardFooter: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "@media(max-width: 600px)": {
      flexDirection: "column"
    }
  },
  authorProfile: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    "@media(max-width: 600px)": {
      flexDirection: "column"
    }
  },
  author: {
    color: o.palette.common.blue400,
    fontSize: o.typography.fontSize16,
    fontWeight: o.typography.fontWeightBold
  },
  designation: {
    color: o.palette.common.grey300,
    fontSize: o.typography.fontSize14
  },
  companyImg: {
    "& > img": {
      maxWidth: 84
    }
  }
}), e = t;
export {
  e as default
};
